import React, { useRef, useEffect, useState, useMemo, useCallback } from "react";
import {
  Box,
  Divider,
  FormControl,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Dropzone, { ExtendedFile } from "../../common/Dropzone";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import {
  useCodetablesSlice,
  getCodeTableValuesByTableName,
  CodeTable,
  fetchAllCodeTablesValues,
} from "../../../redux/slice/codetableSlice";
import { Controller, useForm } from "react-hook-form";
import {
  AddCircleOutlineOutlined,
  CloseOutlined,
  DeleteOutlineOutlined,
  ExitToApp,
  ModeOutlined,
  SaveOutlined,
  ClearOutlined,
  PersonPinCircleTwoTone,
  LocationCityOutlined,
  AttributionOutlined,
  QrCodeOutlined,
  PersonAddAltOutlined
} from "@mui/icons-material";
import CustomRadioButton from "../../common/CustomRadioButton";
import CustomDropdownField from "../../common/CustomDropdownFiled";
import Button from "../../common/Button";
import CustomNametField from "../../common/CustomNametField";
import CustomDatePicker from "../../common/CustomDatePicker";
import CustomAddressTextField from "../../common/CustomAddressTextField";
import CustomTextField from "../../common/CustomTextField";
import CustomTable from "../../common/CustomTable";
import CustomAlert from "../../common/CustomAlert";
import BorderedSection from "../../common/BorderedSection";
import CustomCheckbox from "../../common/CustomCheckBox";
import {
  SingleAlertInfo,
  setSingleAlertObj,
  showHideLoadingDialog,
} from "../../../redux/slice/commonSlice";
import {
  fetchProductItemsByProductId,
  fetchProductsByUserRoleData,
  resetProductItems
} from "../../../redux/slice/product/productListSlice";
import StickTopStepper from "../../common/StickTopStepper";
import Header from "../../common/Header";
import Card from "../../common/Card";
import LegacyToolBar from "../../common/LegacyToolBar";
import {
  getPatient,
  getPatientListByPracticeId,
  saveWoundInfo,
  SaveWoundInfoRequest,
  updatedPatientAddress,
  updatePatientObjectReducer,
  usePatientReducer,
} from "../../../redux/slice/patient/patientSlice";
import { formatAddress, formatDate, formatWoundName, fullName, priceFormatter, getCategoryDisplayLabel } from "../../../utils/Utility";
import { fetchPracticeProductsDataUsingDateOfServiceAndProvider, FetchPracticeProductsParams } from "../../../redux/slice/practice/practiceProductSlice";
import {
  fetchActivePracticeProvidersData,
  usePracticeProvidersSlice,
} from "../../../redux/slice/practice/practiceProvidersSlice";
import {
  fetchActivePracticeLocationsData,
  usePracticeLocationsSlice,
} from "../../../redux/slice/practice/practiceLocationSlice";
import {
  fetchDocumentById,
  getPracticesByUserRole,
  usePracticeSlice,
} from "../../../redux/slice/practiceSlice";
import { useLocation, useNavigate } from "react-router-dom";
import SignaturePad, {
  SignatureData,
} from "../../common/signature/SignaturePad";
import dayjs from "dayjs";
import OptionsPopup, { OptionPopupObjectProps } from "../../common/OptionsPopup";
import { fetchPracticeByIdData } from "../../../redux/slice/practice/practiceEditSlice";
import { PracticeInfo } from "../../../redux/slice/practice/practiceRegistrationSlice";
import { getWoundCodeValuesByWoundCodeType, useWoundCodesSlice } from "../../../redux/slice/ivr/woundCodeSlice";
import CustomIconButton from "../../common/CustomIconButton";
import Cookies from "js-cookie";
import { removeDataFromCookies } from "../../../utils/StorageUtils";
import { fetchAllUserRoles, fetchSecurityTokens, UserRole } from "../../../redux/slice/userSlice";
import { CAN_ACCESS_APPLICATION, ORDERTYPE, PRACTICE_TYPE, PRODUCT_CATEGORY, providerRoleId, USAGE_TYPES, USER_ROLE_ENTITY_NAMES, USER_ROLES } from "../../../constants/applicationConstants";
import SigantureSubmitPopup from "../orders/SignatureSubmitPopup";
import { tokens } from "../../../theme";
import CustomHelpMessage from "../../common/CustomHelpMessage";
import IVRFormWoundInfoPopup from "../ivr/IVRFormWoundInfoPopup";
import AncillaryProductPopup from "./AncillaryProductPopup";
import { useAuthSlice } from "../../../redux/slice/authSlice";
import { addAncillaryOrder, placeOrderCheckBasedOnProviderAndPracticeId, useOrderSlice } from "../../../redux/slice/order/OrderSlice";
import { useNavigation } from "../../../hooks/useNavigation";
import { SUCCESS_CODE } from "../../../service/ServiceConstants";
import moment from "moment";
import IVRFormIncisionInfoPopup from "../ivr/IVRFormIncisionInfoPopup";
import { getProductItemsInProviderTemplateByPatient, updateElementInProductSlice, useProductReducer } from "../../../redux/slice/product/createProductSlice";
import AncillaryProductTypePopup from "./AncillaryProductTypePopup";
import { getByDisplayValue } from "@testing-library/react";
import { fetchIVRById, updateElementInCreateIVRSlice, useCreateIVRSlice } from "../../../redux/slice/ivr/createIVRSlice";
import CustomStyledRadio from "../ivr/CustomStyledRadio";
import CartOptionAncillaryProductPopup from "./CartOptionAncillaryProductPopup";
import { fetchManufacturerDataById } from "../../../redux/slice/manufacturer/ManufacturerSlice";

export interface WoundInfo {
  checkboxes?: JSX.Element;
  woundType: string;
  procedureLocation?: string;
  noOfApplications: string;
  cpt: string;
  cptIds: number[];
  eCode: string;
  eCodeIds: number[];
  iCode: string;
  iCodeIds: number[];
  lCode: string;
  lCodeIds: number[];
  icd10: string;
  icdIds: number[];
  otherDxCodes: string;
  length: number;
  width: number;
  depth: number;
  totalSize: number | string;
  displayTotalSize?: any;
  displayWoundDimensions?: any;
  displayEstimateSurfaceArea?: any;
  displayTotalWoundVolume?: any;
  woundInfoKey?: string;
  incisionMeasurement?: string;
  surgicalIncision?: string;
  exudateDrainage?: string;
  odor?: string;
  periIncisionErythema?: string;
  periIncisionSkin?: string;
  // CS-1310 START
  erythema?: string;
  skin?: string;
  drainage?: string;
  temperature?: string;
  cellulitis?: string;
  //
  periIncisionTemperature?: string;
  //CS-1193 - Start
  dateOfSurgery?: string;
  //CS-1193 - End
  edema?: string;
  eschar?: string;
  undermining?: string;
  tunneling?: string;
  pain?: string;
  severity?: string;
  woundKeyDisplayValue?: string;
  exudate: string | JSX.Element
}
type Option = {
  value: string | number,
  label: string
};
interface Column {
  id: string;
  label: string;
  minWidth?: number;
  align?: "right" | "center" | "left";
  format?: (value: number) => string;
}

export interface ProviderData {
  provider?: string | number| null;
  providerName?: string | null;
  providerNameTypedText?: string | null;
  placeOfService?: string | null;
  practiceLocation?: string | number | null;
  signature?: string | null;
}
export interface AncillaryOrderForm {
  patientId: number | null;
  practiceId: number | null;
  manufacturerId: number | null;
  exudate: any;
  patientinfo: {
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
  // CS-1158 - START
    patientAddress?: string | null;
    StreetAddress?: string | null;
    UnitNumber?: string | null;
    City?: string | null;
    State?: string | null;
    Zipcode?: string | null;
  // CS-1158 - END
  };
  orderConsentInfo: {
    clinicalDocumentationNote: boolean;
  };
  presciptionInfo: {
    routeOfAdministration: string | null;
    durationOfNeed: string | null;
  };
  woundInfo: {
    woundData: {
      woundname?: string;
      woundType: string;
      cpt: string;
      lCode: string;
      eCode: string;
      iCode: string;
      icd10: string;
      otherDxCodes: string;
      noOfApplications: string;
      totalSize: string;
    }[];
    totalSizeOfAllWounds: string;
  };
  providerInfo: ProviderData;
  productInfo: {
    productList?: {
      name: string | null;
      qty: string | null;
      woundName: string | null;
      Amount: string | null;
      productItemId: string | null;
      productId: string | null;
      practiceProductId: string | null;
    }[];
    totalAmount: string | null;
  };
  // CS-1113
  treatmentInformation: {
    homeHealth: string;
    discardedHome?:string;
  };
}


const woundInfoTableColums: Column[] = [
  { id: "woundKeyDisplayValue", label: "ID", minWidth: 20 },
  { id: "woundType", label: "Type", minWidth: 80 },
  { id: "cpt", label: "CPT", minWidth: 50 },
  { id: "lCode", label: "L Code", minWidth: 50 },
  { id: "eCode", label: "E Code ", minWidth: 50 },
  { id: "iCode", label: "I Code", minWidth: 50 },
  // { id: "icd10", label: "ICD10 Code", minWidth: 80 },
  { id: "procedureLocation", label: "Location", minWidth: 80 },
  { id: "otherDxCodes", label: "Dx Code(s) / ICD-10", minWidth: 80 },
  { id: "noOfApplications", label: "# of App ", minWidth: 80 },
  { id: "displayWoundDimensions", label: "Wound Dimensions (L, W, D)", minWidth: 140 },
  { id: "displayEstimateSurfaceArea", label: "Estimate Surface Area (LxW)", minWidth: 120 },
  { id: "displayTotalWoundVolume", label: "Total Wound Volume (LxWxD)", minWidth: 120 },
  { id: "action", label: "Action", minWidth: 20, align: "center" },
];
//CS-1520 START
const getSelectedProductTableColumns = (cartOption: string | null): Column[] => {

  const baseColumns: Column[] = [
    { id: "productName", label: "Name", minWidth: 100 },
  ];

  if (cartOption === "Option 2") {
    baseColumns.push({ id: "usageType", label: "Usage Type", minWidth: 100 });
  }

  // Add remaining columns
  baseColumns.push(
    { id: "frequency", label: "Frequency", minWidth: 100 },
    { id: "qty", label: "QTY", minWidth: 100 },
    { id: "woundName", label: "ID", minWidth: 100 },
    //CS-1187 -Start
    // { id: "amount", label: "Amount" ,minWidth: 100 },
    //CS-1187 -End
    { id: "action", label: "Action", minWidth: 20 }
  );

  return baseColumns;
};
//CS-1520 END

const AncillaryOrderForm: React.FC = () => {
  const {
    control,
    handleSubmit,
    reset,
    getValues,
    setValue,
    formState: { errors },
    watch,
    trigger,
    clearErrors,
    setError
  } = useForm<AncillaryOrderForm>();
  const dispatch = useAppDispatch();
  const { navigate } = useNavigation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [showWoundInfoPopup, setShowWoundInfoPopup] = useState(false);
  const [currentWoundInfo, setCurrentWoundInfo] = useState<{woundInfoKey: string} | null>(null);
  const { allCodeTablesValuesMap, allCodeTableValueFetchStatus } = useCodetablesSlice();
  const [signatureData, setSignatureData] = useState("");
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [isSecondaryInsurance, setIsSecondaryInsurance] = useState(false);
  const [woundInfoRows, setWoundInfoRows] = useState<any[]>([]);
  const [selectedProviderData, setSelectedProviderData] = useState<any[]>([]);// Provider daata should be updated properly as it is used in both IVR Form / Ancillary order also which is passed inside signature data.
  const [patientInfoValid, setPatientInfoValid] = useState(false);
  const [providerInfoValid, setProviderInfoValid] = useState(false);
  const [insuranceInfoValid, setInsuranceInfoValid] = useState(false);
  const [ivRequestValid, setIVRequestValid] = useState(false);
  const [productInfoValid, setProductInfoValid] = useState(false);
  const [consentInfoValid, setConsentInfoValid] = useState(false);
  const [prescriptionInfoValid, setPrescriptionInfoValid] = useState(false);
  const [safeguardQuestionsValid, setSafeguardQuestionsValid] = useState(false);
  const [woundInfoValid, setWoundInfoValid] = useState(false);
  const { patientList, patientInfoObject } = usePatientReducer();
  const { practiceProvidersInfo } = usePracticeProvidersSlice();
  const { practiceLocationsInfo } = usePracticeLocationsSlice();
  const { productItemsInProviderTemplateByPatient } = useProductReducer();
  const [isPatientInfoDisabled, setIsPatientInfoDisabled] = useState(false);
  const [order, setOrder] = useState<{ orderType: string, orderDetails: any, orderDate: string }>({
    orderType: "",
    orderDetails: {},
    orderDate: "",
  });
  const location = useLocation();
  const [practiceID, setPracticeID] = useState("");
  const [disableAllFields, setDisableAllFields] = useState(false);
  //   const [selectedProducts, setSelectedProducts] = useState<Product[]>([]);
  const [selectedProducts, setSelectedProducts] = useState<any>([]);
  const [practiceObject, setPracticeObject] = useState<PracticeInfo>();
  const { allWoundCodesValuesMap, woundCodeFetchStatus } = useWoundCodesSlice();
  const [selectedWoundList, setSelectedWoundList] = useState<string[]>([]);
  const [showOptionPopup, setShowOptionsPopup] = useState<OptionPopupObjectProps>({ message: '', show: false });

  const [showSignatureSubmitPopup, setShowSignatureSubmitPopup] = useState<boolean>(false);
  const [maxWoundRowIndex, setMaxWoundRowIndex] = useState(0);
  const [viewOnly, setIsViewOnly] = useState(false);
  const [patientEmailAddress, setPatientEmailAddress] = useState("");
  const [isSticky, setIsSticky] = useState(false);
  const allowedEntities = [USER_ROLE_ENTITY_NAMES.ADMIN, USER_ROLE_ENTITY_NAMES.PRACTICE, USER_ROLE_ENTITY_NAMES.ACCOUNTEXECUTIVE];
  const [patientData, setPatientData] = useState<any>();
  const { practiceByUserRole } = usePracticeSlice();
  const { IVRObject } = useCreateIVRSlice();
  const { placeOrderPreCheckWithProviderAndPracticeId } = useOrderSlice();
  const { userInfo } = useAuthSlice();
  const canSeePracticeDropdown = allowedEntities.includes(userInfo?.entityName) && order?.orderType !== ORDERTYPE.DIRECT_ORDER;
  const [isDeleting, setIsDeleting] = useState(false);
  const [hasHardStop, setHasHardStop] = useState(false);
  const [maxWoundIdFromMount, setMaxWoundIdFromMount] = useState<number | null>(null);
  const [patientWoundInfo, setPatientWoundInfo] = useState<number | null>(null);
  const [patientAddress, setPatientAddress] = useState<any>()  // CS-1158 
  const [patientAddressChange, setPatientAddressChange] =  useState(false);   // CS-1158 
  const [practiceName, setPracticeName] = useState<any>()
  const [uploadedSupportingDocumentFilesMetaData, setUploadedSupportingDocumentFilesMetaData] = useState<ExtendedFile[]>([]);
  const [showIncisionInfoPopup, setShowIncisionInfoPopup] = useState(false);
  const [ submitAction, setSubmitAction ] = useState(false);
  const [currentProductInfo, setCurrentProductInfo] = useState<any>(null);
  const [ cartOption, setCartOption ] = useState<string | null>(null);
  const [ disableIfProviderTemplate, setDisableIfProviderTemplate ] = useState(false);
  const [exudateLevelList, setExudateLevelList] = useState<CodeTable[]>([]);
  const [ editableWoundKey, setEditableWoundKey ] = useState<string | null>(null);
  const [ woundInfoEdited, setWoundInfoEdited ] = useState(false);
  const [showCartOptionPopup, seShowCartOptionPopup] = useState(false);
  //CS-1302 - Start
  const [manufacturerDetails, setManufacturerDetails] = useState<any>(null);
  //CS-1302 - End
  const [ initialTemplateLoad, setInitialTemplateLoad ] = useState(true);
  //CS-1534 -- Start
  useEffect(() => {
    if (location.state) {
      setValue("patientId", location.state.patientId);
      setValue("practiceId", location.state.practiceId);
      setValue("patientinfo.lastName", location.state?.patientData?.lastName);
      setValue("patientinfo.middleName", location.state?.patientData?.middleName);
      setPatientData(location.state.patientData)
      setPracticeID(location.state.practiceId)
      setPracticeName(location.state.practiceName)
    }
  }, [location.state, setValue]);

  const productOrderOptions = [
    { value: "Option 1", label: "Option 1" },
    { value: "Option 2", label: "Option 2" }
  ];

    useEffect(() => {
    if (location?.state?.patientId) {
      dispatch(getProductItemsInProviderTemplateByPatient({ patientId: location.state.patientId}));
    }
    if(location?.state?.ivrId) {
      dispatch(fetchIVRById({ivrId: location.state.ivrId, isSaveAuditLog: false}));
      
    }
  }, [location.state]);

  useEffect(() => {
    if(IVRObject?.manufacturerCartOption) {
      setCartOption(IVRObject.manufacturerCartOption);
    }; 
  }, [IVRObject]);

  //CS-1520 START
  useEffect(() => {
    if (manufacturerDetails) {
      // Try different possible property names for cartOption
      const cartOptionValue = manufacturerDetails.cartOption ||
        manufacturerDetails.cart_option ||
        manufacturerDetails.manufacturerCartOption ||
        manufacturerDetails.cartOptionName;

      if (cartOptionValue) {
        setCartOption(cartOptionValue);
      } else {
      }
    }
  }, [manufacturerDetails]);

  // Update cartOption when selectedProducts change
  useEffect(() => {
    if (selectedProducts?.length > 0) {
      // Try to get cartOption from the first product
      const productCartOption = selectedProducts[0]?.cartOption;
      if (productCartOption) {
        setCartOption(productCartOption);
      }
    }
  }, [selectedProducts]);
  //CS-1520 END

  const getWoundVolume = (wound: { length?: number | string; width?: number | string; depth?: number | string }) => {
    const length = Number(wound.length);
    const width = Number(wound.width);
    const depth = Number(wound.depth);
    if (isNaN(length) || isNaN(width) || isNaN(depth)) {
      return NaN;
    }
    return length * width * depth;
  };

  const calculatePatientWoundTotalSize = (woundInfo: WoundInfo[]) => {
    let totalValid = 0;
    woundInfo?.forEach((current) => {
      const volume = getWoundVolume(current);
      if (!isNaN(volume)) {
        totalValid += Math.round(volume * 100); //CS-1654
      }
    });
    totalValid = totalValid / 100; //CS-1654
    return totalValid;
  };

  const saveWoundInfoRows = (woundInfoData: WoundInfo[], action?: string) => {
    const formattedWoundData = woundInfoData?.map(wound => {
      const {
        displayTotalSize,
        displayWoundDimensions,
        displayEstimateSurfaceArea,
        displayTotalWoundVolume,
        ...restWoundData
      } = wound;
      return restWoundData;
    });
    const woundInfo = {
      woundData: formattedWoundData,
      totalSizeOfAllWounds: calculatePatientWoundTotalSize(woundInfoData),
      maxWoundId: action === "DELETE" ? maxWoundRowIndex : maxWoundRowIndex + 1
    };

    if (patientData?.patientId) {
      const woundRequest: SaveWoundInfoRequest = {
        patientId: patientData.patientId,
        woundInfo: {
          infoType: "WOUND_INFO",
          isEdited: false,
          patientinfoId: patientWoundInfo,
          infoTypeData: {
            woundInfo: woundInfo
          }
        }
      }
      dispatch(saveWoundInfo(woundRequest));
    }
  };

  useEffect(() => {
    if (allCodeTableValueFetchStatus === "success" && allCodeTablesValuesMap) {
      setExudateLevelList(
        getCodeTableValuesByTableName(allCodeTablesValuesMap, "ExudateLevel")
      )
    }
  }, [allCodeTablesValuesMap, allCodeTableValueFetchStatus]);

  const exudateListOptions = useMemo(() => {
    return exudateLevelList.map(item => ({
      label: item.displayValue,
      value: item.keyName
    }));
  }, [exudateLevelList]);

    const handleExudateChange = (woundInfoKey: any, e: any) => {
    setWoundInfoRows((prev): WoundInfo[] => {
      const rows = prev.map( row => {
        if(row.woundInfoKey == woundInfoKey) {
          return {
            ...row,
            exudate: e?.value
          }
        }else {
          return row
        }
      }  
      )
      return rows;
    })
    setEditableWoundKey(null)
    setWoundInfoEdited(true);
  }

  const handleExudateClick = (woundInfoKey: any, exudate: any) => {
    const prevExudate = getValues(`exudate.exudate_${woundInfoKey}`)
    woundInfoKey && setEditableWoundKey(woundInfoKey);
    woundInfoKey && !prevExudate && setValue(`exudate.exudate_${woundInfoKey}`, exudate)
    setWoundInfoRows((prev): WoundInfo[] => {
      const rows = prev.map( row => {
        if(row.woundInfoKey == woundInfoKey) {
          return {
            ...row,
            exudate: exudate
          }
        } 
        return row;
      }  
      )
      return rows;
    })
  };

  const exudateComponent = (woundInfoKey: any, exudate: any) => {
    return (
      editableWoundKey === woundInfoKey ? (
          <CustomDropdownField
            name={`exudate.exudate_${woundInfoKey}`}
            control={control}
            options={exudateListOptions}
            label="Exudate"
            onChangeSelect={(e) => { handleExudateChange(woundInfoKey, e) }}
            onBlur={ () => setEditableWoundKey(null) }
            sortOptions={false}
          />
      ) :
        (<Typography
          onClick={() => handleExudateClick(woundInfoKey, exudate)}
          sx={{
            cursor: "pointer",
            color: "white"
          }}
        >
          {exudate || "Click to Edit"}
        </Typography>)
    )
  }

  const formattedWoundRows = useMemo(() => {
    const rows: WoundInfo[] = woundInfoRows.map(row => {
      return {
        ...row,
        exudate: exudateComponent(row.woundInfoKey, row.exudate)
      }
    });
    if(woundInfoEdited) {
        saveWoundInfoRows(woundInfoRows);
        setWoundInfoEdited(false);
    }
    
    return rows
  }, [woundInfoRows, woundInfoEdited])

  const defaultValues = useCallback(() => {
    const infoTypeMapping = {
      SUPPORTING_DOCUMENT: setUploadedSupportingDocumentFilesMetaData,
    };
    Object.entries(infoTypeMapping).forEach(([infoType, setter]) => {
      const data = location.state.patientData.patientInfo.find(
        (info:any) => info.infoType === infoType
      );

      if (data?.patientinfoData?.ivrDocumentListDTOs) {
        const documentsMetaData = data.patientinfoData.ivrDocumentListDTOs.map(
          ({ documentId, documentName, documentType, size, auditTimestamp }: { documentId: number; documentName: string; documentType: string; size: number; auditTimestamp: string }) => ({
            documentId: documentId.toString(),
            name: documentName,
            type: documentType || "Unknown",
            size: size,
            timestamp: auditTimestamp,
            lastModified: 0,
            webkitRelativePath: "",
            arrayBuffer: async () => new ArrayBuffer(0),
            bytes: async () => new Uint8Array(0),
            slice: () => new Blob(),
            stream: () => new ReadableStream(),
            text: async () => "",
          })
        );

        setter(documentsMetaData);
      }
    });
    const woundInfo = location.state.patientData?.patientInfo?.find((info: any) => info.infoType === 'WOUND_INFO' && info.inactiveDate === null);
    setPatientWoundInfo(woundInfo?.patientinfoId);
    let processedWoundData = woundInfo?.patientinfoData?.woundInfo?.woundData?.map((woundData: WoundInfo, i: number) => {
      const totalSize = parseFloat(woundData.totalSize as unknown as string);
      const totalSizeFormatted = isNaN(totalSize) ? '0.00' : totalSize.toFixed(2);
      const cptFormatted = Array.isArray(woundData.cpt) ? woundData.cpt.join(', ') : woundData.cpt;
      const lengthValue = parseFloat(woundData.length as unknown as string);
      const widthValue = parseFloat(woundData.width as unknown as string);
      const depthValue = parseFloat(woundData.depth as unknown as string);
      const estimateSurfaceArea = (!isNaN(lengthValue) && !isNaN(widthValue))
        ? (lengthValue * widthValue).toFixed(2)
        : '0.00';
      const totalWoundVolume = (!isNaN(lengthValue) && !isNaN(widthValue) && !isNaN(depthValue))
        ? (lengthValue * widthValue * depthValue).toFixed(2)
        : '0.00';
      const woundInfoKey =  woundData.woundInfoKey ? woundData.woundInfoKey : generateUniqueId(maxWoundRowIndex > 0 ? maxWoundRowIndex + 1  : i);
      return {
        woundType: woundData.woundType,
        procedureLocation: woundData.procedureLocation,
        cpt: cptFormatted,
        cptIds: woundData.cptIds,
        lCode: woundData.lCode,
        lCodeIds: woundData.lCodeIds,
        icd10: woundData.icd10,
        icdIds: woundData.icdIds,
        eCode: woundData.eCode,
        eCodeIds: woundData.eCodeIds,
        iCode: woundData.iCode,
        iCodeIds: woundData.iCodeIds,
        otherDxCodes: woundData.woundType === "Surgical Incision" ? woundData.icd10 : woundData.otherDxCodes,
        noOfApplications: woundData.noOfApplications,
        length: woundData.length,
        width: woundData.width,
        depth: woundData.depth,
        exudate: woundData.exudate,
        totalSize: totalSizeFormatted,
        displayWoundDimensions: `${woundData.length}cm X ${woundData.width}cm X ${woundData.depth}cm`,
        displayEstimateSurfaceArea: `${estimateSurfaceArea}cm²`,
        displayTotalWoundVolume: `${totalWoundVolume}cm³`,
        woundInfoKey: woundInfoKey,
        incisionMeasurement: woundData.incisionMeasurement,
        surgicalIncision: woundData.surgicalIncision,
        exudateDrainage: woundData.exudateDrainage,
        odor: woundData.odor,
        periIncisionErythema: woundData.periIncisionErythema,
        periIncisionSkin: woundData.periIncisionSkin,
        // CS-1310 START
        skin: woundData.skin,
        drainage: woundData.drainage,
        erythema: woundData.erythema,
        cellulitis: woundData.cellulitis,
        temperature: woundData.temperature,
        //
        periIncisionTemperature: woundData.periIncisionTemperature,
        //CS-1193 -Start
        dateOfSurgery: woundData.dateOfSurgery,
        //CS-1193 -End
        edema: woundData.edema,
        eschar: woundData.eschar,
        undermining: woundData.undermining,
        tunneling: woundData.tunneling,
        pain: woundData.pain,
        severity: woundData.severity,
        woundKeyDisplayValue: formatWoundName(woundData.woundType, woundInfoKey)
      };
    });
    setWoundInfoRows(processedWoundData || []);

      // CS-1158 - START
    const addressInfo = location.state.patientData?.patientInfo?.find((info: any) => info.infoType === "ADDRESS" && info.inactiveDate === null);
    
    if (addressInfo?.patientinfoData) {
      const {
        patientStreetAddress,
        patientUnitNumber,
        patientCity,
        patientState,
        patientZip,
      } = addressInfo.patientinfoData;
    
      setValue("patientinfo.StreetAddress", patientStreetAddress);
      setValue("patientinfo.UnitNumber", patientUnitNumber);
      setValue("patientinfo.City", patientCity);
      setValue("patientinfo.State", patientState);
      setValue("patientinfo.Zipcode", patientZip);

      const formattedAddress = {
        patientStreetAddress,
        patientUnitNumber,
        patientCity,
        patientState,
        patientZip
    }
        // formatAddress.filter(part => !!part && part.trim() !== '') 
        // .join(', ');
    
      // Example: if you're storing it in state
      setPatientAddress(formattedAddress);
    }
      // CS-1158 - END
    reset(
      {
        woundInfo: {
          woundData: processedWoundData,
          totalSizeOfAllWounds: woundInfo?.totalSizeOfAllWounds,
        }
      })

    checkWoundInfoValidity(getValues());

  }, [location.state.patientData])

  useEffect(() => {
    defaultValues();
  }, [location.state.patientData])


  useEffect(() => {
    // setUserRole();
    fetchPracticeListByUserRole();
    dispatch(fetchProductsByUserRoleData(true));
    //CS-1158
    setValue('presciptionInfo.routeOfAdministration',"Self");
    setValue('presciptionInfo.durationOfNeed',"30 Days");
    checkPrescriptionInfoValidity({ ...watch() })
    checkSafeguardQuestionsValidity({ ...watch() })
    //
  }, []);


  useEffect(() => {
    hideDataWithSticky();
  }, []);

  //CS-1520
  const selectedProductTableColumns = useMemo(() => {
    return getSelectedProductTableColumns(cartOption);
  }, [cartOption]);

  const selectedProductRows: any[] = useMemo(() => {

    const rows: any[] = []
    //CS-1302 - Extracting the common manufacturerId from the selected product
    if (selectedProducts?.length > 0) {
      const commonManufacturerId = selectedProducts[0].manufacturerId;
      //CS-1534 - Provider phase 2 change
      const providerId = getValues("providerInfo.provider");
      // Fetch manufacturer details once
      if (!manufacturerDetails || manufacturerDetails?.id !== commonManufacturerId) {
        dispatch(fetchManufacturerDataById(commonManufacturerId))
          .then((response) => {
            if(response?.payload?.data && response?.payload?.data?.data?.customConfig?.provider_signature_required === "Y" && providerId && practiceID){
              dispatch(placeOrderCheckBasedOnProviderAndPracticeId({ practiceId: Number(practiceID), providerId: Number(providerId) })).then((res)=>{
                if (res?.payload && res?.payload?.canDirectPlaceOrder === false && res?.payload?.providerUserExist === false) {
                  setShowOptionsPopup({
                    message: "Provider user is missing. Still order will be created but it will not be processed further.",
                    show: true,
                    variant: "warning",
                    buttons: [
                      //CS-1534 - not blocking the order if authorised user not exist , order will be in pending state
                    //   {
                    //   name: "Add Provider User", color: 'success', onClick: () => {
                    //     navigate("/user_create", { state: { providerData: { providerId: providerId, entityIds: practiceID } } });
                    //   }
                    // },
                     { name: "Ok", color: 'success', onClick: cancelOptionPopup }]
                  });
                } else {
                }
              })
            }
            setManufacturerDetails(response?.payload?.data?.data);
          })
          .catch((error) => {
            console.error(`Failed to fetch manufacturer ${commonManufacturerId}`, error);
          });
      }
    }
    //CS - 1302 - End

    selectedProducts?.map((item: any) => {
      const row = {
        ...item,
        productName: item?.selectedProducts?.label,
        frequency: "Once Daily",//CS-1187 - item?.frequency
        qty: item.qty,
        woundName: item?.wound?.woundDisplayValue,
        practiceProductId: item?.selectedProducts?.practiceProductId,
        usageType: item?.selectedProducts?.usageType,
        dressingType: item?.selectedProducts?.dressingType,
        //CS -1187 -start
        // amount: priceFormatter(item.qty * item?.selectedProducts?.extendedPrice),
        //CS -1187 -end
      }
      rows.push(row);
    })
    return rows;
  }, [selectedProducts , watch("providerInfo.provider")]);

  const dressTypeMap = new Map<string, string>(
    [["ancillaryDressing", USAGE_TYPES.ANCILLARY],
    ["primaryDressing", USAGE_TYPES.PRIMARY],
    ["secondaryDressing", USAGE_TYPES.SECONDARY]]
  );

  useEffect(() => {
    const rows: any[] = []
     
    initialTemplateLoad && productItemsInProviderTemplateByPatient && productItemsInProviderTemplateByPatient?.map((item: any) => {
      setCartOption(item.cartOption)
      setDisableIfProviderTemplate(true);
      const incision = woundInfoRows?.find(incision => incision.woundInfoKey === item.incisionId);
      if (incision) {
        const row = {
          // productName: `${item.sku}${item.productItemDescription ? ` - ${item.productItemDescription}` : ''}`,
          // value: item.productItemId,
          // productItemId: item.productItemId,
          frequency: "Once Daily",//CS-1187 - item?.frequency
          qty: item.qty || 1,
          woundName: item.incisionId,
          wound: {
            woundDisplayValue: formatWoundName("Surgical Incision", item.incisionId),
            woundInfoKey: item.incisionId
          },
          selectedProducts: {
            label: `${item.sku}${item.productItemDescription ? ` - ${item.productItemDescription}` : ''}`,
            practiceProductId: item.practiceProductId,
            productId: item.productId,
            value: item.productItemId,
            productItemId: item.productItemId,
            dressingType: item.dressingType,
            usageType: dressTypeMap.get(item.dressingType),
            extendedPrice: item.extendedPrice
          },
          // productId: item.productId,
          // practiceProductId: item.practiceProductId,
          // dressingType: item.dressingType,
          // usageType: dressTypeMap.get(item.dressingType),
          manufacturerId: item.manufacturerId
        }
        rows.push(row);
      }
    });
    initialTemplateLoad && productItemsInProviderTemplateByPatient?.length > 0 && setSelectedProducts(rows);
    if (rows.length > 0) {
      setInitialTemplateLoad(false);
    };
  }, [productItemsInProviderTemplateByPatient, woundInfoRows])

  const fetchPracticeListByUserRole = async () => {
    const response = await dispatch(fetchAllUserRoles());
    if (response?.meta?.requestStatus === 'fulfilled') {
      if (response?.payload) {
        const userRoles = response.payload;
        const role = userRoles?.find((role: UserRole) => role.roleName === userInfo.userRole);
        if (role) {
          dispatch((getPracticesByUserRole(false)))
        };
      };
    };
  };
  const hideDataWithSticky = () => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setIsSticky(offset > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }

  const clickShowWoundInfoPopup = () => {
    setShowWoundInfoPopup(true);
    // setShowErrorAlert(false);
  };

  const getActivePrimaryInsurance = () => {
    return patientData?.patientInfo?.find(
      (item: { infoType: string; inactiveDate: string | null }) =>
        item.infoType === "PRIMARY_INSURANCE" && item.inactiveDate === null
    );
  };
  // CS-1113
  const homeHealthValue = watch("treatmentInformation.homeHealth");
  const discardedHome = watch("treatmentInformation.discardedHome");
  
  const shouldShowWarning = hasHardStop;

  //CS-1680
  const handleSafeguard = (field: string, value: string) => {
    setValue(field as any, value);
  
    //CS-1519
    setTimeout(() => {
      checkSafeguardQuestionsValidity({ ...watch() });
    }, 0);

    // CS-1680: Show error popup logic
    // If first question is "No", show popup only once (not for second question changes)
    // If first question is "Yes", show popup only when second question is "Yes"
    const shouldShowPopup = 
      (field === "treatmentInformation.discardedHome" && value === "No") ||
      (field === "treatmentInformation.homeHealth" && value === "Yes" && discardedHome === "Yes");

    if (shouldShowPopup) {
      setShowOptionsPopup({
        show: true,
        variant: "error",
        message: (
          <>
            <strong>Order Blocked:</strong> The patient does not meet criteria.  
            <br />
            Please check discharge and home health status before proceeding.
          </>
        ),
        buttons: [
          {
            name: "OK",
            color: "error",
            onClick: () => {
              setShowOptionsPopup({ show: false, message: "" });
              setHasHardStop(true);
            },
          },
        ],
      });
    } else {
      // CS-1680: Only clear hard stop if the blocking condition is actually resolved
      // Don't clear if first question is still "No" or second question is still "Yes"
      const currentDiscardedHome = field === "treatmentInformation.discardedHome" ? value : discardedHome;
      const currentHomeHealth = field === "treatmentInformation.homeHealth" ? value : homeHealthValue;
      
      if (currentDiscardedHome !== "No" && currentHomeHealth !== "Yes") {
        setHasHardStop(false);
      }
    }
  };
  //
  
  const getMaxWoundInfoKey = (rows: WoundInfo[]): number => {
    const maxKey = rows.reduce((max, row) => {
      if (row.woundInfoKey) {
        const parts = row.woundInfoKey.split('_');
        const num = parseInt(parts[parts.length - 1], 10);
        if (!isNaN(num) && num > max) {
          return num;
        }
      }
      return max;
    }, 0);
    return maxKey;
  };


     useEffect(() => {
      if (maxWoundIdFromMount) {
          setMaxWoundRowIndex(maxWoundIdFromMount);
          setMaxWoundIdFromMount(null);
      } else if (!isDeleting && woundInfoRows && woundInfoRows.length > 0) {
          const maxNumber = getMaxWoundInfoKey(woundInfoRows);
          setMaxWoundRowIndex(maxNumber);
      }

      if (isDeleting) {
          saveWoundInfoRows(woundInfoRows, "DELETE");
          setIsDeleting(false);
      }
  }, [woundInfoRows]);

  const generateUniqueId = (index: number): string => {
    return `${`WOUND`}_${index}`;
  };
  const placesOfService = useMemo(() => {
    let placeOfService: CodeTable[] = [];
    if (allCodeTablesValuesMap) {
      placeOfService = getCodeTableValuesByTableName(allCodeTablesValuesMap, "PlaceOfService");
    }
    if (!placeOfService || placeOfService.length === 0) {
      dispatch(fetchAllCodeTablesValues());
    }
    let options: { label: string, value: any }[] = [];
    placeOfService?.map((option) => {
      options.push({ label: option.displayValue, value: option.keyName });

    });
    return options;
  }, [allCodeTablesValuesMap]);

  // CS-1113
  useEffect(() => {
    if (placesOfService.length > 0) {
      const selectedPOS = watch('providerInfo.placeOfService');
      if (!selectedPOS) {
        setValue('providerInfo.placeOfService', 'Home (12)');
      }
    }
  }, [placesOfService]);
  //

  const practiceProvidersOptions = useMemo(() => {
    let options: { label: string; value: number }[] = [];
    practiceProvidersInfo?.map((option: any) => {
      options.push({
        label: `${option.firstName ? option.firstName : ""} ${option.middleName ? option.middleName + " " : ""
          }${option.lastName ? option.lastName : ""}`,
        value: option.providerId,
      });
    });
    return options;
    return [];
  }, [practiceProvidersInfo]);

  const practiceLocationsOptions = useMemo(() => {
    let options: { label: string; value: number }[] = [];
    practiceLocationsInfo?.map((option: any) => {
      const locationParts = [option.streetAddress, option.unitNumber, option.city, option.state, option.zipCode];
      const filteredLocationParts = locationParts.filter(part => part !== undefined && part !== null && part.trim() !== "");
      const locationName = filteredLocationParts?.join(", ")
      options.push({
        // label: `${option.streetAddress} ${option.unitNumber} ${option.city} ${option.state} ${option.zipCode}`,
        label: locationName,
        value: option.locationId,
      });
    });
    return options;
  }, [practiceLocationsInfo]);

    // CS-1158 - START
  // CS-1113
  // useEffect(() => {
  //   if (practiceLocationsOptions.length === 1) {
  //     const existingValue = watch("providerInfo.practiceLocation");
  //     if (!existingValue) {
  //       setValue("providerInfo.practiceLocation", practiceLocationsOptions[0].value);
  //     }
  //   }
  // }, [practiceLocationsOptions]);
  //
    // CS-1158 - END
  useEffect(() => {
    if (practiceID) {
      dispatch(fetchActivePracticeProvidersData({ productId: practiceID, onlyActiveRecords: true }));
      dispatch(fetchActivePracticeLocationsData(practiceID));
      fetchPatientsList();
      setValue("practiceId", parseInt(practiceID));
    }
  }, [practiceID]);

  const fetchPatientsList = async () => {
    await dispatch(getPatientListByPracticeId({ practiceId: practiceID }));
  };

  useEffect(() => {
    const calculateTotalSize = () => {
      let totalValid = 0;
      let foundValidNumber = false;

      const woundData = woundInfoRows.map((current) => {
        const volume = getWoundVolume(current);
        if (!isNaN(volume)) {
          totalValid += Math.round(volume * 100); //CS-1654
          foundValidNumber = true;
        }

        return {
          woundType: current.woundType,
          noOfApplications: current.noOfApplications,
          cpt: current.cpt,
          eCode: current.eCode,
          iCode: current.iCode,
          lCode: current.lCode,
          icd10: current.icd10,
          otherDxCodes: current.otherDxCodes,
          totalSize: current?.totalSize?.toString(),
        };
      });

      totalValid = totalValid / 100; //CS-1654
      setValue("woundInfo.woundData", woundData);
      if (foundValidNumber) {
        setValue("woundInfo.totalSizeOfAllWounds", totalValid.toString());
      } else {
        setValue("woundInfo.totalSizeOfAllWounds", "");
      }
      trigger("woundInfo.totalSizeOfAllWounds");
      trigger("woundInfo.woundData");
    };

    calculateTotalSize();
  }, [woundInfoRows, setValue]);

  const handleProviderChange = () => {
    const providerId = getValues("providerInfo.provider");
    const selectedProvider =
      practiceProvidersInfo &&
      practiceProvidersInfo.find(
        (provider: any) => provider.providerId === (providerId)
      );
    if (selectedProvider != undefined) {
      const data = [
        {
          providerName: fullName(
            "",
            selectedProvider?.firstName,
            selectedProvider?.middleName,
            selectedProvider?.lastName
          ),
          // npi: selectedProvider?.npi,
          // ptan: selectedProvider?.ptan,
          // taxId: selectedProvider?.taxId,
        },
      ];
      setSelectedProviderData(data);
    } else {
      setSelectedProviderData([]);
    }
  };
  const totalAmount = selectedProducts?.reduce((sum: any, row: any) => {
    return sum + Number(row?.qty * row?.selectedProducts?.extendedPrice);
  }, 0);

useEffect(() => {
  if (selectedProducts?.length > 0) {
    const prodcutData = selectedProducts?.map((product: any) => ({
      name: product?.selectedProducts?.label,
      frequency: product?.frequency,
      qty: product?.qty,
      woundInfoKey: product?.wound?.woundInfoKey,
      amount: (product?.selectedProducts?.extendedPrice * product?.qty).toString(),
      productItemId: product?.selectedProducts?.productItemId,
      productId: product?.selectedProducts?.productId,
      practiceProductId: product?.selectedProducts?.practiceProductId,
    }));
    
    const productInfo = {
      productList: prodcutData,
      totalAmount: totalAmount
    }
    
    setValue("productInfo", productInfo);
  
    setTimeout(() => {
      const formData = watch();
      checkProductInfoValidity(formData);
    }, 0);
  } else {
    setProductInfoValid(false);
  }
}, [selectedProducts, cartOption, productItemsInProviderTemplateByPatient, totalAmount, setValue, watch]);

 const handleAddWoundInfo = (woundInfoData: WoundInfo) => {
    const lengthValue = parseFloat(woundInfoData.length as unknown as string);
    const widthValue = parseFloat(woundInfoData.width as unknown as string);
    const depthValue = parseFloat(woundInfoData.depth as unknown as string);
    const estimateSurfaceArea = (!isNaN(lengthValue) && !isNaN(widthValue))
      ? (lengthValue * widthValue).toFixed(2)
      : '0.00';
    const totalWoundVolume = (!isNaN(lengthValue) && !isNaN(widthValue) && !isNaN(depthValue))
      ? (lengthValue * widthValue * depthValue).toFixed(2)
      : '0.00';
    const displayWoundDimensions = `${woundInfoData.length}cm X ${woundInfoData.width}cm X ${woundInfoData.depth}cm`;
    const displayEstimateSurfaceArea = `${estimateSurfaceArea}cm²`;
    const displayTotalWoundVolume = `${totalWoundVolume}cm³`;

    const updatedWoundInfoData = {
      ...woundInfoData,
      displayWoundDimensions,
      displayEstimateSurfaceArea,
      displayTotalWoundVolume,
    };
    let updatedWoundInfoData2 = { ...updatedWoundInfoData };
      if(woundInfoData){
      const cptFormatted = Array.isArray(updatedWoundInfoData2.cpt) ? updatedWoundInfoData2.cpt.join(', ') : updatedWoundInfoData2.cpt;
      const eCodesFormatted = Array.isArray(updatedWoundInfoData2.eCode) ? updatedWoundInfoData2.eCode.join(', ') : updatedWoundInfoData2.eCode;
      const iCodesFormatted = Array.isArray(updatedWoundInfoData2.iCode) ? updatedWoundInfoData2.iCode.join(', ') : updatedWoundInfoData2.iCode;
      const lCodesFormatted = Array.isArray(updatedWoundInfoData2.lCode) ? updatedWoundInfoData2.lCode.join(', ') : updatedWoundInfoData2.lCode;
      const icd10Formatted = Array.isArray(updatedWoundInfoData2.icd10) ? updatedWoundInfoData2.icd10.join(', ') : updatedWoundInfoData2.icd10;

      const woundInfoKey = updatedWoundInfoData2?.woundInfoKey ? updatedWoundInfoData2?.woundInfoKey : generateUniqueId(maxWoundRowIndex + 1);
      updatedWoundInfoData2 = {
        ...updatedWoundInfoData2,
        cptIds: (woundInfoData.cptIds || []).map(id => Number(id)).filter(id => !isNaN(id)),
        eCodeIds: (woundInfoData.eCodeIds || []).map(id => Number(id)).filter(id => !isNaN(id)),   
        iCodeIds: (woundInfoData.iCodeIds || []).map(id => Number(id)).filter(id => !isNaN(id)),
        lCodeIds: (woundInfoData.lCodeIds || []).map(id => Number(id)).filter(id => !isNaN(id)),
        icdIds: (woundInfoData.icdIds || []).map(id => Number(id)).filter(id => !isNaN(id)),
        cpt: cptFormatted,
        eCode: eCodesFormatted,
        iCode: iCodesFormatted,
        lCode: lCodesFormatted,
        icd10: icd10Formatted,
        otherDxCodes: woundInfoData.woundType === "Surgical Incision" ? icd10Formatted : woundInfoData.otherDxCodes,
        woundInfoKey: woundInfoKey,
        woundKeyDisplayValue: formatWoundName(woundInfoData.woundType, woundInfoKey)
      };
      if (currentWoundInfo) {
        const updatedWoundInfo = woundInfoRows.map((item) =>
          item.woundInfoKey === currentWoundInfo.woundInfoKey ? updatedWoundInfoData2 : item
        );
        setWoundInfoRows(updatedWoundInfo);
        saveWoundInfoRows(updatedWoundInfo);
      } else {
        const newWoundRows = [...woundInfoRows, updatedWoundInfoData2]
        setWoundInfoRows(newWoundRows);
        saveWoundInfoRows(newWoundRows);
      }
      setShowWoundInfoPopup(false);
      setCurrentWoundInfo(null);
    }
  };


  useEffect(() => {
    checkWoundInfoValidity({ ...watch() });
  }, [woundInfoRows]);

  //CS-1519
  useEffect(() => {
    checkSafeguardQuestionsValidity({ ...watch() });
  }, [homeHealthValue, discardedHome]);

  //CS-1680: Monitor safeguard questions and set hard stop accordingly
  useEffect(() => {
    // Hard stop should be active if first question is "No" OR second question is "Yes"
    if (discardedHome === "No" || homeHealthValue === "Yes") {
      setHasHardStop(true);
    } else {
      setHasHardStop(false);
    }
  }, [homeHealthValue, discardedHome]);

  const legacyItems = [
    { icon: <ModeOutlined color="info" />, text: "Edit" },
    { icon: <DeleteOutlineOutlined color="error" />, text: "Delete" },
  ];
  const isDeletingRef = useRef(false); // flag to restrict double calling of the function

  const deleteWoundInfoRow = (rowIndex: number, woundInfoKey?: string) => {
    if (isDeletingRef.current) return;
    isDeletingRef.current = true;
    setIsDeleting(true);
    onDeleteClick(rowIndex,woundInfoKey);

    setTimeout(() => {
      isDeletingRef.current = false;
    }, 100);
  };
  const setWoundInfoDeletePopup = (rowIndex: number, woundInfoKey?: string) => {
    setShowOptionsPopup({
      message: `Wound information will be deleted from the patient profile permanently. Do you wish to proceed?`,
      show: true,
      variant: "warning",
      buttons: [{ name: "Yes", color: 'primary', onClick: () => deleteWoundInfoRow(rowIndex, woundInfoKey) }, { name: "No", color: 'error', onClick: cancelOptionPopup }]
    });
  }
  const woundInfoActionComponent = (
    row: any,
    rowIndex: number
  ): JSX.Element => {
    return (
      <>
        <CustomIconButton
          color="info"
          size="small"
          variant="outlined"
          tooltipMessage="Edit"
          tooltipPlacement="top"
          onClick={() => onEditClick(row, rowIndex, "woundInfo")}
        // style={{ display: `${hideElement(checkHasIvr(row?.woundInfoKey))}` }}
        >
          <ModeOutlined fontSize="small" />
        </CustomIconButton>{" "}
        {!row.productItemId || row.productItemId === 0 ? (
          <CustomIconButton
            color="error"
            size="small"
            variant="outlined"
            tooltipMessage="Delete"
            tooltipPlacement="top"
            onClick={() => setWoundInfoDeletePopup(rowIndex, row?.woundInfoKey)}
          // style={{ display: `${hideElement(checkHasIvr(row?.woundInfoKey))}` }}
          >
            <DeleteOutlineOutlined fontSize="small" />
          </CustomIconButton>
        ) : null}
      </>
    );
  };

  // CS-1306 - START
  const onEditProductClick = (row: any, rowIndex: number) => {
    // Find the original product object from selectedProducts using rowIndex
    const product = selectedProducts[rowIndex];
    setCurrentProductInfo({ ...product, rowIndex });
    seShowCartOptionPopup(true);
  };

  const onDeleteProductClick = (rowIndex: number) => {
    setSelectedProducts((prev: any[]) => prev.filter((_, idx) => idx !== rowIndex));
  };

  const setProductDeletePopup = (rowIndex: number) => {
    setShowOptionsPopup({
      message: `Product will be removed from the selection. Do you wish to proceed?`,
      show: true,
      variant: "warning",
      buttons: [
        { name: "Yes", color: 'primary', onClick: () => { onDeleteProductClick(rowIndex); cancelOptionPopup(); } },
        { name: "No", color: 'error', onClick: cancelOptionPopup }
      ]
    });
  };

  const productSelectionActionComponent = (row: any, rowIndex: number): JSX.Element => (
    <>
      <CustomIconButton
        color="info"
        size="small"
        variant="outlined"
        tooltipMessage="Edit"
        tooltipPlacement="top"
        onClick={() => onEditProductClick(row, rowIndex)}
      >
        <ModeOutlined fontSize="small" />
      </CustomIconButton>{" "}
      <CustomIconButton
        color="error"
        size="small"
        variant="outlined"
        tooltipMessage="Delete"
        tooltipPlacement="top"
        onClick={() => setProductDeletePopup(rowIndex)}
      >
        <DeleteOutlineOutlined fontSize="small" />
      </CustomIconButton>
    </>
  );
  // CS-1306 - END

  const cancelOptionPopup = () => {
    setShowOptionsPopup({ message: "", show: false });
  };

  const onEditClick = useCallback(
    (row: any, rowIndex: number, fieldName: string) => {
      setCurrentWoundInfo(row);
      if (row?.woundType === "Surgical Incision") {
        setShowIncisionInfoPopup(true);
      } else {
        setShowWoundInfoPopup(true);
      }
    },
    []
  );

  const onDeleteClick = (rowIndex: number,woundInfoKey?: string) => {
    setWoundInfoRows((currentRows) => {
      const updatedRows = currentRows.filter((_, index) => index !== rowIndex);
      return updatedRows;
    });
    checkWoundInfoValidity({ ...watch() });
    cancelOptionPopup();
    setSelectedProducts((prev: any[]) => {
      return prev?.filter(row => row.woundName !== woundInfoKey);
    });
  };

  const onCancelClick = async () => {
    // if (IVRFetchStatus !== "success" && patientFetchStatus != "success") {
    //   const faceSheetDocumentIds = getValues("patientInfo.faceSheet");
    //   const insuranceCardsDocumentIds = getValues(
    //     "insuranceInfo.insuranceCards"
    //   );
    //   const secondaryInsuranceCardsDocumentIds = getValues(
    //     "insuranceInfo.secondaryInsuranceCards"
    //   );
    //   const supportingDocsDocumentIds = getValues(
    //     "supportingDocumentation.supportingDocuments"
    //   );
    //   const imagesOfWOundsDocumentIds = getValues(
    //     "supportingDocumentation.imageOfWounds"
    //   );

    //   // Combine all IDs into a single array
    //   const allDocumentIds = [
    //     ...faceSheetDocumentIds,
    //     ...insuranceCardsDocumentIds,
    //     ...supportingDocsDocumentIds,
    //     ...imagesOfWOundsDocumentIds,
    //   ];

    //   // removeIVRDocument for each ID
    //   const removePromises = allDocumentIds.map((id) =>
    //     dispatch(removeIVRDocument(id.toString()))
    //   );
    //   // Wait for all removeIVRDocument dispatches to complete
    //   // await Promise.all(removePromises);
    // }
    navigate(-1);
  };


  const checkWoundInfoValidity = (data: any) => {
    const { woundInfo } = data;
    if (woundInfo) {
      const { totalSizeOfAllWounds } = woundInfo;
      const isValid =
        !!totalSizeOfAllWounds &&
        Array.isArray(woundInfoRows) &&
        woundInfoRows.length > 0;
      setWoundInfoValid(isValid);
    } else {
      setWoundInfoValid(false);
    }
  };

  const checkProviderInfoValidity = (data: any) => {
    const { providerInfo } = data;
      // CS-1158 
    // if (providerInfo && providerInfo.placeOfService && providerInfo.practiceLocation && providerInfo.provider) {
    if (providerInfo && providerInfo.placeOfService && providerInfo.provider) {
      setProviderInfoValid(true);
    } else {
      setProviderInfoValid(false);
    }
  };
  const checkProductInfoValidity = (data: any) => {
    const { productInfo } = data;
    if (productInfo && productInfo?.productList && productInfo?.productList?.length > 0 && productInfo?.totalAmount) {
      setProductInfoValid(true);
      return true;
    } else {
      setProductInfoValid(false);
      return false;
    }
  };
  const checkPrescriptionInfoValidity = (data: any) => {
    const { presciptionInfo } = data;
    if (presciptionInfo && (presciptionInfo?.durationOfNeed ||  presciptionInfo?.routeOfAdministration)) {
      setPrescriptionInfoValid(true);
    } else {
      setPrescriptionInfoValid(false);
    }
  };
  //CS-1519, CS-1680
  const checkSafeguardQuestionsValidity = (data: any) => {
    const { treatmentInformation } = data;
    // CS-1680: Both questions must be answered for validation
    if (treatmentInformation && treatmentInformation?.discardedHome && treatmentInformation?.homeHealth) {
      setSafeguardQuestionsValid(true);
    } else {
      setSafeguardQuestionsValid(false);
    }
  };

  const checkConsentInfoValidity = (data: any) => {
    const { orderConsentInfo } = data;
    if (orderConsentInfo && orderConsentInfo?.clinicalDocumentationNote && orderConsentInfo?.clinicalDocumentationNote === true) {
      setConsentInfoValid(true);
    } else {
      setConsentInfoValid(false);
    }
  };
  const handleErrorResponse = (response: any, defaultMessage: string) => {
    if (response?.payload?.errors) {
      const combinedErrorMessage = response.payload.errors
        .map((err: any) => err.errorMessage || defaultMessage)
      // .join();

      let errorObj: SingleAlertInfo = {
        message: combinedErrorMessage,
        alertType: "error",
      };
      return dispatch(setSingleAlertObj(errorObj));
    }
  };
  const hasNestedErrors = (obj: any) => {
    for (const key in obj) {
      if (obj[key] && typeof obj[key] === 'object') {
        if (hasNestedErrors(obj[key])) {
          return true;
        }
      } else {
        return true;
      }
    }
    return false;
  };
  const onSubmit = async (data: any) => {
    const productSelected = checkProductInfoValidity({ ...watch() })
    if (productSelected) {
      //CS-1302 - By passing the signature if provider_signature_required is "Y"
      if (manufacturerDetails?.customConfig?.provider_signature_required === "Y" && !placeOrderPreCheckWithProviderAndPracticeId?.canDirectPlaceOrder) {
        const updatedObject = await mapOrderInfoToOrderObjectInfo(data);
         setShowOptionsPopup({
          message: "Do you really want to create the order?",
          show: true,
          variant: "confirm",
          buttons: [{ name: "Confirm", color: 'primary', onClick: () =>submitOrderAfterSign(updatedObject) }, { name: "Cancel", color: 'secondary', onClick: cancelOptionPopup }]
        });
      } else {
        await mapOrderInfoToOrderObjectInfo(data);
        setShowSignatureSubmitPopup(true);
      }
      // CS-1302 - END
    } else {
      let errorObj: SingleAlertInfo = {
        message: 'No products selected.',
        alertType: "error",
      };
      return dispatch(setSingleAlertObj(errorObj));
    }
  };
  const onError = (_errors: any, e: any) => {
    if (hasNestedErrors(_errors)) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      return;
    }
  };


  const handleSignatureData = async (data: any) => {
    setValue("providerInfo.signature", data.providerInformation.signature);
    setValue("providerInfo.providerNameTypedText", data.providerInformation.name);

    // // Wait for React Hook Form to update state
    await trigger();

    // // Get the updated form values
    const updatedData = getValues();

    const updatedObject = mapOrderInfoToOrderObjectInfo(updatedData);
    submitOrderAfterSign(updatedObject);
  }

  const submitOrderAfterSign = async (updatedObject: any) => {
    // CS-1158 - START
    const patientAddress = {
      patientStreetAddress: updatedObject?.orderInfo?.patientInfo?.patientStreetAddress,
      patientUnitNumber: updatedObject?.orderInfo?.patientInfo?.patientUnitNumber,
      patientCity: updatedObject?.orderInfo?.patientInfo?.patientCity,
      patientState: updatedObject?.orderInfo?.patientInfo?.patientState,
      patientZipcode: updatedObject?.orderInfo?.patientInfo?.patientZipcode,
    };    
    if(patientAddressChange){
      const response = await dispatch(updatedPatientAddress({ patientId: patientData.patientId, patientAddress }));    
      if (response?.payload?.code !== SUCCESS_CODE) {
        dispatch(setSingleAlertObj({
          message: response?.payload?.message || "Failed to Update Patient Address.",
          alertType: "error"
        }));
        return;
      }
    }
    console.log(updatedObject)
    // CS-1158 - END
    const response = await dispatch(addAncillaryOrder(updatedObject));
    if (response.meta.requestStatus === 'fulfilled') {
      // cs-347 (13/9/2024) - Display Order Number or IVR Number in Success Messages
      const orderNumber = response?.payload?.orderNumber;
      let successObj: SingleAlertInfo = {
        //CS-1248 - Changing the name from Ancillary to Collagen
        message: `${getCategoryDisplayLabel(allCodeTablesValuesMap, PRODUCT_CATEGORY.CONSERVATIVE)} Order ` + orderNumber + " created successfully.",
        alertType: "success"
      };

      setShowOptionsPopup({ message: "", show: false });
      //
      dispatch(setSingleAlertObj(successObj));
      // if (location && location.state && location.state.fromUI && location.state.fromUI === "IVRList") {
      //   navigate("/order_list");
      // } else {
      //   // navigate(-1);
      navigate("/order_list");
      // }
    }

    // const response = await dispatch(submitIVR(updatedObject));
    // if (response.payload && response.payload.message === "SUCCESS") {
    //   // cs-347 (13/9/2024) - Display Order Number or IVR Number in Success Messages
    //   // (Here if we are creating multiple IVR also onFinalSubmit, we get only one IVRNumber in response!)
    //   const ivrNumber = response.payload?.data?.ivrNumber;
    //   let successObj: SingleAlertInfo = {
    //     message: "IVR " + ivrNumber + " Saved Successfully",
    //     alertType: "success",
    //   };
    //   dispatch(setSingleAlertObj(successObj));
    //   navigate("/ivr_list", { state: { withSearchHistory: true } });
    // } else {
    //   return handleErrorResponse(response, "IVR Submission Failed.");
    // }
  }

  //   const submitIVRAfterSign = async (updatedObject: any) => {
  //     // const response = await dispatch(submitIVR(updatedObject));
  //     if (response.payload && response.payload.message === "SUCCESS") {
  //       // cs-347 (13/9/2024) - Display Order Number or IVR Number in Success Messages
  //       // (Here if we are creating multiple IVR also onFinalSubmit, we get only one IVRNumber in response!)
  //       const ivrNumber = response.payload?.data?.ivrNumber;
  //       let successObj: SingleAlertInfo = {
  //         message: "IVR " + ivrNumber + " Saved Successfully",
  //         alertType: "success",
  //       };
  //       dispatch(setSingleAlertObj(successObj));
  //       navigate("/ivr_list", { state: { withSearchHistory: true } });
  //     } else {
  //       return handleErrorResponse(response, "IVR Submission Failed.");
  //     }
  //   }

  const providerInformationRef = useRef<HTMLDivElement>(null);
  const safeguardQuestionsRef = useRef<HTMLDivElement>(null);
  const woundDataRef = useRef<HTMLDivElement>(null);
  const productSelectionRef = useRef<HTMLDivElement>(null);
  // CS-1187 - START
  // const prescriptionInformation = useRef<HTMLDivElement>(null);
  // CS-1187 - END
  const consentRef = useRef<HTMLDivElement>(null);

  const [activeStep, setActiveStep] = useState<number>(0);
  const [firstLoad, setFirstLoad] = useState(true);
  const steps = [
    //CS-1158
    { stepName: "Information", isCompleted: providerInfoValid },
    //
    { stepName: "Safeguard Questions", isCompleted: safeguardQuestionsValid },
    { stepName: "Data", isCompleted: woundInfoValid },
    { stepName: "Product Selection", isCompleted: productInfoValid },
    //CS-1187 - START
    // { stepName: "Prescription Information", isCompleted: prescriptionInfoValid },
    //CS-1187 - END
    { stepName: "Consent", isCompleted: consentInfoValid },
  ];

  useEffect(() => {
    const scrollToElement = (elementRef: any) => {
      if (elementRef && elementRef.current) {
        elementRef.current.scrollIntoView({ behavior: "smooth" });
      } else {
      }
    };


    // Always scroll when activeStep changes (except initial load to step 0)
    if (activeStep > 0 || !firstLoad) {
      switch (activeStep) {
        case 0:
          scrollToElement(providerInformationRef);
          break;
        case 1:
          scrollToElement(safeguardQuestionsRef);
          break;
        case 2:
          scrollToElement(woundDataRef);
          break;
        case 3:
          scrollToElement(productSelectionRef);
          break;
        // CS-1187 - START
        // case 4:
        //   scrollToElement(prescriptionInformation);
        //   break;
        // CS-1187 - END
        case 4:
          scrollToElement(consentRef);
          break;
        default:
          break;
      }
    }

    if (firstLoad) {
      setFirstLoad(false);
    }
  }, [activeStep]);
  const signedInPractice: any = useMemo(() => {
    const selectedPracticeId = location.state?.practiceId;
    if (practiceByUserRole && (userInfo?.userRole === USER_ROLES.ROLE_PRACTICESTAFF)) {
      return practiceByUserRole[0];
    } else if (selectedPracticeId && practiceByUserRole && canSeePracticeDropdown) {
      const selectedPractice = practiceByUserRole.find(practice => practice.practiceId === selectedPracticeId);
      if (selectedPractice) {
        return selectedPractice;
      }
      return null;
    } else if (order?.orderDetails?.practiceId && practiceByUserRole) {
      const selectedPractice = practiceByUserRole.find(practice => practice.practiceId === order?.orderDetails?.practiceId);
      if (selectedPractice) {
        return selectedPractice;
      }
      return null;
    }
    return null;
    // getValues('practiceDropdown'),
  }, [practiceByUserRole, order?.orderDetails]);

  const providerOptions: Option[] = useMemo(() => {
    let options: Option[] = [];
    const today = dayjs();

    if (order?.orderType !== ORDERTYPE.DIRECT_ORDER) {
      signedInPractice?.practiceProviders?.map((provider: any) => {

        if (provider.inactiveDate === null || (dayjs(provider.inactiveDate).isValid() && dayjs(provider.inactiveDate).isAfter(dayjs(today))) ||
          (dayjs(provider.inactiveDate).isValid() && dayjs(provider.inactiveDate).isSame(dayjs(today)))) {
          const providerName = fullName(provider.title ? provider.title : null, provider.firstName, provider.middleName, provider.lastName);
          options.push({
            label: providerName,
            value: provider.providerId
          });
        }
      })
    } else {
      if (order?.orderDetails?.providerName) {
        options.push({
          label: order.orderDetails.providerName,
          value: order.orderDetails.providerId
        });
        setValue("providerInfo.provider", order.orderDetails.providerId);
      } else {
        signedInPractice?.practiceProviders?.map((provider: any) => {

          if (provider.inactiveDate === null || (dayjs(provider.inactiveDate).isValid() && dayjs(provider.inactiveDate).isAfter(dayjs(today))) ||
            (dayjs(provider.inactiveDate).isValid() && dayjs(provider.inactiveDate).isSame(dayjs(today)))) {

            const providerName = fullName(null, provider.firstName, provider.middleName, provider.lastName);
            options.push({
              label: providerName,
              value: provider.providerId
            });
          }
        })

        if (order?.orderDetails?.orderInfo?.providerId) {
          setValue("providerInfo.provider", order?.orderDetails?.orderInfo?.providerId);
        }
      }
    };
    return options;
  }, [order, practiceByUserRole, signedInPractice]);

    const baseWoundColumns: Column[] = [
      { id: "woundKeyDisplayValue", label: "ID", minWidth: 20 },
      { id: "woundType", label: "Type", minWidth: 80 },
      { id: "cpt", label: "CPT", minWidth: 50 },
      { id: "lCode", label: "L Code", minWidth: 50 },
      { id: "eCode", label: "E Code ", minWidth: 50 },
      { id: "iCode", label: "I Code", minWidth: 50 },
      // { id: "icd10", label: "ICD10 Code", minWidth: 80 },
      { id: "procedureLocation", label: "Location", minWidth: 80 },
      { id: "otherDxCodes", label: "Dx Code(s) / ICD-10", minWidth: 80 },
      // { id: "noOfApplications", label: "# of App ", minWidth: 80 },
      { id: "exudate", label: "Exudate", minWidth: 80 },
      { id: "displayWoundDimensions", label: "Wound Dimensions (L, W, D)", minWidth: 140 },
      { id: "displayEstimateSurfaceArea", label: "Estimate Surface Area (LxW)", minWidth: 120 },
      { id: "displayTotalWoundVolume", label: "Total Wound Volume (LxWxD)", minWidth: 120 },
      { id: "action", label: "Action", minWidth: 20, align: "center" },
    ];
  
  // const shouldShowExudate = useMemo(() => {
  //     return woundInfoRows.some(row => row.woundType === "Surgical Incision");
  // }, [woundInfoRows]);
  
  const woundInfoTableColumns: Column[] = useMemo(() => {
      const filteredColumns = baseWoundColumns.filter(
          column => !((column.id === "lCode" || column.id === "eCode" || column.id === "iCode" || column.id === "cpt") && signedInPractice?.specialization === PRACTICE_TYPE.SURGICAL)
      );
      // const insertIndex = filteredColumns.findIndex(col => col.id === "displayTotalSize");
      // if (shouldShowExudate && insertIndex !== -1) {
      //     const exudateColumn = { id: "exudate", label: "Exudate", minWidth: 80 };
      //     return [
      //         ...filteredColumns.slice(0, insertIndex),
      //         exudateColumn,
      //         ...filteredColumns.slice(insertIndex)
      //     ];
      // }
      return filteredColumns;
  }, [signedInPractice]);

  // CS - 1158 - START 
  useEffect(() => {
    if (providerOptions.length === 1) {
      const selectedPOS = watch('providerInfo.provider');
      if (!selectedPOS) {
        setValue('providerInfo.provider', providerOptions[0].value);
      }
    } else if (location?.state?.providerId) {
      setValue("providerInfo.provider", location.state.providerId);
      checkProviderInfoValidity({ ...watch() })
    }
    handleProviderChange();
  }, [providerOptions, location?.state?.providerId]);
  // CS - 1158 - END 
  const mapOrderInfoToOrderObjectInfo = (data: any) => {
    const woundData = woundInfoRows?.map((row) => ({
      woundType: row.woundType,
      procedureLocation:row.procedureLocation,
      cpt: row.cpt,
      cptIds: row.cptIds,
      lCode: row.lCode,
      lCodeIds: row.lCodeIds,
      eCode: row.eCode,
      eCodeIds: row.eCodeIds,
      iCode: row.iCode,
      iCodeIds: row.iCodeIds,
      icd10: row.icd10,
      icdIds: row.icdIds,
      otherDxCodes: row.otherDxCodes,
      noOfApplications: row.noOfApplications,
      length: row.length,
      width: row.width,
      depth: row.depth,
      woundInfoKey: row.woundInfoKey,
      woundKeyDisplayValue:row.woundKeyDisplayValue, // CS - 1187
      totalSize: row.totalSize.toString(),
      incisionMeasurement: row.incisionMeasurement ,
      surgicalIncision: row.surgicalIncision ,
      exudateDrainage: row.exudateDrainage ,
      odor: row.odor ,
      // CS-1310 START
      skin: row.skin,
      drainage: row.drainage,
      cellulitis: row.cellulitis,
      erythema: row.erythema,
      temperature: row.temperature,
      //
      periIncisionErythema: row.periIncisionErythema ,
      periIncisionSkin: row.periIncisionSkin ,
      periIncisionTemperature: row.periIncisionTemperature ,
      exudate: row.exudate,
      //CS-1193 -Start
      dateOfSurgery: row.dateOfSurgery ? moment(row.dateOfSurgery?.toString())?.format("MM/DD/YYYY") : "",
      //CS-1193 -End
      edema: row.edema ,
      eschar: row.eschar ,
      undermining: row.undermining  ,
      tunneling: row.tunneling ,
      pain: row.pain ,
      severity: row.severity 
    }));

    const woundInfo = {
      woundData: woundData,
      totalSizeOfAllWounds: parseFloat(getValues('woundInfo.totalSizeOfAllWounds')),
    };

    const prodcutData = selectedProducts?.map((product: any) => ({
      name: product?.selectedProducts?.label,
      frequency: "Once Daily",//product?.frequency //CS-1187
      qty: product?.qty,
      woundInfoKey: product?.wound?.woundInfoKey,
      amount: (product?.selectedProducts?.extendedPrice * product?.qty).toString(),
      productItemId: product?.selectedProducts?.productItemId,
      productId: product?.selectedProducts?.productId,
      practiceProductId: product?.selectedProducts?.practiceProductId,
      usageType: product?.selectedProducts?.usageType,
      dressingType: product?.selectedProducts?.dressingType,
      noOfDays: product?.noOfDays
    }))

    const productInfo = {
      productList: prodcutData,
      totalAmount: totalAmount
    }

    const mappedData: any = {
      practiceId: practiceID,
      patientId: patientData?.patientId,
      manufacturerId: selectedProducts?.find((row: any) => row?.manufacturerId)?.manufacturerId,
      orderType: "DIRECT_ORDER",
      requestedDeliveryDate: "",
      requestedShippingMethod: "Ground",
      // dateOfService: patientData?.dateOfSurgery,
      dateOfService: null,//CS-1451
      manufacturerEmailEnable: null,
      ivrId: location?.state?.ivrId,
      orderInfo: {
        patientInfo: {
          firstName: patientData?.firstName,
          lastName: patientData?.lastName,
          middleName: patientData?.middleName,
          // CS-1158 - START
          patientStreetAddress:getValues("patientinfo.StreetAddress"),
          patientUnitNumber: getValues("patientinfo.UnitNumber"),
          patientCity: getValues("patientinfo.City"),
          patientState: getValues("patientinfo.State"),
          patientZipcode: getValues("patientinfo.Zipcode"),
          // CS-1158 - END
        },
        orderConsentInfo: {
          clinicalDocumentationNote: data.orderConsentInfo.clinicalDocumentationNote
        },
        //CS-1187 - START
        // presciptionInfo: {
        //   routeOfAdministration: data?.presciptionInfo?.routeOfAdministration,
        //   durationOfNeed: data?.presciptionInfo?.durationOfNeed,
        // },
        //CS-1187 - END
        woundInfo: woundInfo,
        providerInfo: {
          providerId: data.providerInfo.provider,
          providerNameTypedText:providerOptions.find((option) => option.value === data.providerInfo.provider)?.label,
          providerName: providerOptions.find((option) => option.value === data.providerInfo.provider)?.label,
          placeOfService: data.providerInfo.placeOfService,
          // practiceLocation: data.providerInfo.practiceLocation,        // CS-1158 
          signature: getValues("providerInfo.signature"),
        },
        productInfo: productInfo,
        additionalNotes:{
          comments:data?.comments
        },
        safeguardQuestions:{
          isReceivingHomeHealth : data?.treatmentInformation?.homeHealth,
          isDiscardedToHome : data?.treatmentInformation?.discardedHome,
        }
      }
    };

    return mappedData;
  };




  const handleKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      const target = event.target as HTMLElement;
      if (!target.getAttribute('data-allow-submit')) {
        event.preventDefault();
      }
    }
  };

  // CS-1158 - START
  useEffect(() => {
    if (patientAddress) {
        setValue("patientinfo.StreetAddress", patientAddress.patientStreetAddress || "");
        setValue("patientinfo.UnitNumber", patientAddress.patientUnitNumber || "");
        setValue("patientinfo.City", patientAddress.patientCity || "");
        setValue("patientinfo.State", patientAddress.patientState || "");
        setValue("patientinfo.Zipcode", patientAddress.patientZip || "");
    }
}, [patientAddress, setValue]);
  // CS-1158 - END

  const clickShowIncisionInfoPopup = () => {
    setShowIncisionInfoPopup(true);
  };

//unmount
  useEffect(() => () => {
    dispatch(updateElementInProductSlice({
      elementName: "productItemsInProviderTemplateByPatient",
      value: []
    }));
    dispatch(updateElementInCreateIVRSlice({
      elementName: "IVRObject",
      value: undefined
    }));
  }, []);

  return (
    <>
      {showCartOptionPopup && (
        <CartOptionAncillaryProductPopup
          open={showCartOptionPopup}
          onClose={() => {
            seShowCartOptionPopup(false);
            setCurrentProductInfo(null);
          }}
          editPricing={true}
          editProduct={!!currentProductInfo}
          practiceId={location?.state?.practiceId}
          providerId={getValues("providerInfo.provider")}
          woundData={woundInfoRows}
          // Pass the product to edit for autofill
          currentProductInfo={currentProductInfo}
          onAddProduct={(product) => {
            if (currentProductInfo && typeof currentProductInfo.rowIndex === "number") {
              setSelectedProducts((prev: any[]) =>
                prev.map((item, idx) => idx === currentProductInfo.rowIndex ? product : item)
              );
            } else {
              setSelectedProducts((prevProducts: any) => [...prevProducts, product]);
            }
            setCurrentProductInfo(null);
          }}
          selectedManufactureID={selectedProducts ? selectedProducts?.find((row: any) => row?.manufacturerId)?.manufacturerId : null}
          practiceSpecialization={signedInPractice?.specialization}
          cartOptionName={selectedProducts[0]?.cartOption || null}
        />
      )}
      {showWoundInfoPopup &&
        <IVRFormWoundInfoPopup
          open={showWoundInfoPopup}
          onClose={() => {
            setShowWoundInfoPopup(false);
            setCurrentWoundInfo(null);
          }}
          currentWoundInfo={currentWoundInfo}
          onAddWoundInfo={handleAddWoundInfo}
          from={CAN_ACCESS_APPLICATION.ORDER_MANAGEMENT}
        />}
      {showIncisionInfoPopup &&
        <IVRFormIncisionInfoPopup
          open={showIncisionInfoPopup}
          onClose={() => {
            setShowIncisionInfoPopup(false);
            setCurrentWoundInfo(null);
          }}
          currentIncisionInfo={currentWoundInfo}
          onAddIncisionInfo={handleAddWoundInfo}
          from={CAN_ACCESS_APPLICATION.ORDER_MANAGEMENT}
        />
      }
      <Box sx={{
        margin: {
          xs: "20px 10px",
          sm: "20px",
        },
      }}>
        {/* CS-1158 */}
        {/* CS-1290 - Title changes */}
        <Header title={`Create ${getCategoryDisplayLabel(allCodeTablesValuesMap, PRODUCT_CATEGORY.CONSERVATIVE)} Order`} />
        {/* // */}
        <Card>
          <Box sx={{ position: "sticky", top: 0, zIndex: 1100 }}>
            <StickTopStepper
              activeStep={activeStep}
              setActiveStep={setActiveStep}
              steps={steps}
              isViewMobile={false}
              content={
                (
                  <Box display="flex" alignItems="center" gap={2} mt={1} flexWrap="wrap">
                    <Box display="flex" alignItems="center" gap={1}>
                      <AttributionOutlined sx={{ color: "#bbb" }} />
                      <Typography sx={{ color: colors.success[300], fontWeight: "bold" }}>Patient: </Typography>
                      <Typography variant="h6" fontWeight="bold" sx={{ color: colors.grey[100] }}>
                        {fullName("", patientData?.firstName, patientData?.middleName, patientData?.lastName)}
                      </Typography>
                    </Box>
                    {/* {!isSticky && (
                      <>
                        <Typography variant="body2" color="#bbb" sx={{mr:4}}>
                          <strong>DOB:</strong> {getValues(`patientInfo.patientDOB`)} | <strong>Gender:</strong> {getValues(`patientInfo.gender`)}
                        </Typography>
                        <Box  display="flex" alignItems="center">
                          <LocationCityOutlined sx={{ color: "#bbb",mr:1 }} />
                          <Typography variant="body2" color="#bbb">
                          {formatAddress(
                            getValues(`patientInfo.patientStreetAddress`),
                            getValues(`patientInfo.patientUnitNumber`),
                            getValues(`patientInfo.patientCity`),
                            getValues(`patientInfo.patientState`),
                            getValues(`patientInfo.patientZipcode`)
                          )}
                          </Typography>
                        </Box>
                        </>
                    )} */}
                  </Box>
                )
              }
            />
            {/* <Box
              sx={{
                position: "relative",
                background: "rgba(255, 255, 255, 0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "8px",
                padding: "8px",
                color: "#fff",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                width: "100%",
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1.02)",
                  background: "#2C3339",
                },
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#28A745",
                  fontWeight: "bold",
                  position: "absolute",
                  top: "-12px",
                  left: "16px",
                  background: "#2C3339",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                }}
              >
                Patient
              </Typography>
              <Box display="flex" alignItems="center" gap={2} mt={1} flexWrap="wrap">
                  <Box display="flex" alignItems="center" gap={1}>
                    <AttributionOutlined sx={{ color: "#bbb" }} />
                    <Typography variant="h6" fontWeight="bold"  sx={{color: colors.grey[100]}}>
                    {fullName("", getValues("patientInfo.patientFirstName"), getValues("patientInfo.patientMiddleName"), getValues("patientInfo.patientLastName"))}
                    </Typography>
                  </Box>
                  {!isSticky && (
                    <>
                      <Typography variant="body2" color="#bbb" sx={{mr:4}}>
                        <strong>DOB:</strong> {getValues(`patientInfo.patientDOB`)} | <strong>Gender:</strong> {getValues(`patientInfo.gender`)}
                      </Typography>
                      <Box  display="flex" alignItems="center">
                        <LocationCityOutlined sx={{ color: "#bbb",mr:1 }} />
                        <Typography variant="body2" color="#bbb">
                        {formatAddress(
                          getValues(`patientInfo.patientStreetAddress`),
                          getValues(`patientInfo.patientUnitNumber`),
                          getValues(`patientInfo.patientCity`),
                          getValues(`patientInfo.patientState`),
                          getValues(`patientInfo.patientZipcode`)
                        )}
                        </Typography>
                      </Box>
                      </>
                   )}
              </Box>
            </Box> */}
          </Box>
          <form onSubmit={handleSubmit(onSubmit, onError)}>
            <Box>
              <Box mt={4} ref={providerInformationRef}>
                <BorderedSection
                  title={
                    <>
                    {/* CS-1158 */}
                      Information{" "}
                      {/* // */}
                      {/* <CustomHelpMessage
                        title="Help"
                        message={
                          <Typography fontWeight="bold">
                            Please select the "Date of Service" 
                            {isPracticeIndividual && ' and the "Provider"'} to choose the product.
                          </Typography>
                        }
                      /> */}
                    </>
                  }
                >
                  <Grid container spacing={2}>
                    {/* <Grid item md={2} xs={12}>
                      <CustomDatePicker
                        controllerName={`treatmentInformation.${"dateOfService"}`}
                        control={control}
                        label="DOS"
                        rules={{
                          required: "Date of Service is required.",
                          validate: {
                            isValidDate: (
                              value:
                                | string
                                | number
                                | Date
                                | dayjs.Dayjs
                                | null
                                | undefined
                            ) =>
                              dayjs(value, "MM/DD/YYYY", true).isValid() ||
                              "Invalid date format.",
                          },
                        }}
                        onChange={(e) => {
                          checkProductInfoValidity({ ...watch() });
                          setValue("treatmentInformation.practiceProductId", 0)
                          setValue("treatmentInformation.productSizes", [])
                          setSelectedProducts([]);
                          dispatch(resetProductItems());
                        }}
                        // onBlur={(e) => {
                        //   if (moment(e.target.value, "MM/DD/YYYY", true).isValid()) {
                        //     handleFetchPracticeProducts(e.target.value, parseInt(practiceID));
                        //   } else {
                        //     setDisableProductField(true);
                        //   }
                        // }}
                        // onClose={() => {
                        //   const date = getValues("treatmentInformation.dateOfService");
                        //   const providerId = getValues("providerInformation.provider");
                        //   handleFetchPracticeProducts(date, parseInt(practiceID), parseInt(providerId));
                        // }}
                        disabled={disableAllFields}
                      />
                    </Grid> */}
                    <Grid item md={2} xs={12}>
                      <CustomDropdownField
                        name="providerInfo.provider"
                        control={control}
                        options={providerOptions}
                        onChangeSelect={() => {
                          checkProviderInfoValidity({ ...watch() });
                          handleProviderChange()
                        }}
                        label="Provider"
                        // disabled={location.state?.orderType==="orderedFromPatientList"? false : order?.orderType !== ORDERTYPE.DIRECT_ORDER && isDisableProducts}
                        rules={{ required: "Provider is required." }}
                        disabled={providerOptions?.length === 1 ? true : false} // CS -1158
                      />
                    </Grid>
                    <Grid item md={2} xs={12}>
                      <CustomDropdownField
                        control={control}
                        name='providerInfo.placeOfService'
                        options={placesOfService}
                        label="POS"
                        rules={{ required: "Place(s) of Service is required." }}
                        onChangeSelect={(e) => { checkProviderInfoValidity({ ...watch() }) }}
                        disabled={disableAllFields}
                        sortOptions={false}
                      />
                    </Grid>
                    {/*  CS-1158 - START */}
                    {/* CS-1113 */}
                    {/* {practiceLocationsOptions.length >1 ? (
                    <Grid item md={5} xs={12}>
                      <CustomDropdownField
                        name="providerInfo.practiceLocation"
                        control={control}
                        options={practiceLocationsOptions}
                        label="Practice Location"
                        rules={{ required: "Practice Location is required." }}
                        onChangeSelect={(e) => { checkProviderInfoValidity({ ...watch() }) }}
                        disabled={disableAllFields}
                      />
                    </Grid>
                    ):(
                      <Grid item md={5} xs={12}>
                      <CustomTextField
                        controllerName="providerInfo.practiceLocation"
                        control={control}
                        label="Practice Location"
                        readOnly={true}
                        value={practiceLocationsOptions[0]?.label || ""}
                      />
                    </Grid>
                      )} */}
                  <Grid item md={12} xs={12} mt={1}>
                          <Typography variant="h5" sx={{ fontWeight: "bold" }}>Patient Address</Typography>
                  </Grid>
                  <Grid item md={12} xs={12}>
                      <CustomAddressTextField
                          control={control}
                          name="patientinfo"
                          // context="Patient"
                          useAutoComplete={true}
                          setValue={setValue}
                          isRequired={true}
                          onChange={() => { 
                            setPatientAddressChange(true);
                          }} 
                      // isDisabled={disablePatientName}
                      />
                  </Grid>
                  </Grid>
                  {/*  CS-1158 - END */}
                </BorderedSection>
              </Box>


              {/* CS-1680: Safeguard Questions - Both visible without dependency */}
              <Box mt={4} ref={safeguardQuestionsRef}>
                <BorderedSection title="Safeguard Questions">
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: { xs: "block", md: "flex" },
                      alignItems: "center",
                    }}
                  >
                    <label style={{ marginRight: "20px" }}>
                    Will the patient be discharged to the home (12) before intended treatment start date?  <span style={{ color: colors.success[200], fontSize: 18 }}> * </span>
                    </label>
                    <CustomRadioButton
                      control={control}
                      controllerName="treatmentInformation.discardedHome"
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      rules={{ required: "Please select the option" }}
                      onChange={(e) =>
                        handleSafeguard(
                          "treatmentInformation.discardedHome",
                          e.target.value
                        )
                      }
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: { xs: "block", md: "flex" },
                      alignItems: "center",
                    }}
                  >
                    <label style={{ marginRight: "20px" }}>
                      Is this patient currently receiving home health?  <span style={{ color: colors.success[200], fontSize: 18 }}> * </span>
                    </label>
                    <CustomRadioButton
                      control={control}
                      controllerName="treatmentInformation.homeHealth"
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      rules={{ required: "Please select the option" }}
                      onChange={(e) =>
                        handleSafeguard(
                          "treatmentInformation.homeHealth",
                          e.target.value
                        )
                      }
                    />
                  </Grid>
                  {shouldShowWarning && ( 
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: { xs: "block", md: "flex" },
                        alignItems: "center",
                      }}
                    >
                      <label style={{ marginRight: "20px", color: "red", fontWeight: "bold" }}>
                        🚫 STOP: The patient does not meet the required criteria for Home (12).
                      </label>
                    </Grid>
                  )}
                  
                </BorderedSection>
              </Box>


              <Box mt={4} ref={woundDataRef}>
                <BorderedSection title="Data">
                  <Grid container spacing={2}>
                    <Controller
                      name={`woundInfo.woundData`}
                      control={control}
                      rules={{
                          validate: (value: any) => {
                              const emptyExudate = woundInfoRows?.some((row: { exudate: string; }) => !row.exudate || row.exudate === "")
                              if ( submitAction && value.length > 0 && woundInfoRows.length > 0 && emptyExudate) {
                                  return "Exudate is required.";
                              }
                              return true;
                          }
                      }}
                      render={({ field, fieldState }) => {
                        const hasWoundInformation =
                          getValues("woundInfo.woundData")?.length > 0;
                        return (
                          <>
                            <Grid
                              container
                              justifyContent="flex-end"
                              sx={{ flexWrap: "wrap" }}
                              spacing={1}
                            >
                              { signedInPractice?.specialization !== PRACTICE_TYPE.SURGICAL &&
                                <Grid item xs={12} sm="auto">
                                  <Button
                                    sx={{ mb: 1 }}
                                    color={
                                      fieldState.error && !hasWoundInformation
                                        ? "error"
                                        : "info"
                                    }
                                    startIcon={<AddCircleOutlineOutlined />}
                                    onClick={() => clickShowWoundInfoPopup()}
                                    fullWidth
                                  >
                                    Add Wound
                                  </Button>
                                </Grid>
                              }
                              {(signedInPractice?.specialization === PRACTICE_TYPE.SURGICAL || signedInPractice?.specialization === PRACTICE_TYPE.WOUND_CARE_AND_SURGICAL) &&
                                <Grid item xs={12} sm="auto">
                                  <Button
                                    sx={{ mb: 1 }}
                                    color={
                                      fieldState.error && !hasWoundInformation
                                        ? "error"
                                        : "info"
                                    }
                                    startIcon={<AddCircleOutlineOutlined />}
                                    onClick={() => clickShowIncisionInfoPopup()}
                                    // disabled={disableIfProviderTemplate}
                                    fullWidth
                                  >
                                    Add Incision
                                  </Button>
                                </Grid>
                              }
                            </Grid>

                            {fieldState.error && (
                              <Typography
                                color="error"
                                variant="body2"
                                style={{ marginTop: "1px", marginLeft: "15px" }}
                              >
                                {fieldState.error.message}
                              </Typography>
                            )}

                            <Grid item md={12} xs={12}>
                              {/* <LegacyToolBar items={legacyItems}/> */}
                              <CustomTable
                                key={editableWoundKey}
                                columns={woundInfoTableColumns}
                                rows={formattedWoundRows || []}
                                actionComponent={(row: any, rowIndex: number) =>
                                  woundInfoActionComponent(row, rowIndex)
                                }
                                disablePagination={true}
                                borderBox={true}
                                showMenu={true}
                              />
                            </Grid>
                          </>
                        );
                      }}
                    />
                    <Grid item md={2} xs={12}>
                      <CustomTextField
                        controllerName={`woundInfo.${"totalSizeOfAllWounds"}`}
                        control={control}
                        label="Total Volume of All Wounds(cm³)"
                        isNumberOnly={true}
                        rules={{
                          required: "Total Volume of all wounds is required.",//CS-1605
                          min: { value: 0.01, message: "Total Volume of all wounds must be greater than 0." },
                        }}
                        // rules={{
                        //     validate: (value: string) => {
                        //         if (submitAction === "submitAction" && !value) {
                        //             return "Total Volume of all wounds is required.";
                        //         }
                        //         return true;
                        //     }
                        // }}
                        onChange={(e) => {
                          checkWoundInfoValidity({ ...watch() });
                        }}
                      // isDisabled={disableAllFields}
                      />
                    </Grid>
                  </Grid>
                </BorderedSection>
              </Box>
              <Box mt={4} ref={productSelectionRef}>
                <BorderedSection title="Product Selection">
                  <Grid container spacing={2} mb={2} justifyContent="space-between">
                    <Grid item xs={4}>
                      <Typography>
                        <b>Product:</b>
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Grid container style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }} spacing={2}>
                        <Grid item>
                          <Button
                            color="info"
                            startIcon={<QrCodeOutlined />}
                            // disabled={disableIfProviderTemplate}
                            onClick={() => {seShowCartOptionPopup(true)}}
                          >
                            Order Products
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item md={12} xs={12}>
                      <CustomTable
                        columns={selectedProductTableColumns}
                        rows={selectedProductRows || []}
                        disablePagination={true}
                        borderBox={true}
                        emptyText="No Product Found"
                        showMenu={true}
                        actionComponent={productSelectionActionComponent}
                      />
                    </Grid>
                    {/* CS-1187 - Start */}
                    {/* <Grid item md={2} xs={12}>
                      <CustomTextField
                        control={control}
                        label="Total Amount"
                        value={priceFormatter(totalAmount)}
                      isDisabled={true}
                      />
                      </Grid> */}
                      {/* CS -1187 - End */}
                  </Grid>
                </BorderedSection>
              </Box>
              
              <Box mt={4}>
                <BorderedSection title="Medical Notes"
                  hasCollapse={true}
                  defaultExpanded={false}>
                  <Grid container spacing={2} alignItems="flex-end">
                    <Grid item md={6} xs={12}>
                      <Grid container spacing={2}>
                        <Grid item md={6} xs={12}>
                          <Dropzone
                            control={control}
                            name={`supportingDocumentation.${"supportingDocuments"}`}
                            onFileChange={()=>{}}
                            initialFilesMetaData={uploadedSupportingDocumentFilesMetaData}
                            holdOnChange={true}
                            isDisabled={false}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </BorderedSection>
              </Box>
              {/* CS-1187 - START  */}
              {/* <Box mt={4} ref={prescriptionInformation}>
                <BorderedSection title="Prescription Information">
                  <Grid container spacing={2} xs={12}>
                    <Grid item md={4} xs={12}>
                      <CustomTextField
                        name="presciptionInfo.routeOfAdministration"
                        controllerName="presciptionInfo.routeOfAdministration"
                        control={control}
                        onChange={(e) => { checkPrescriptionInfoValidity({ ...watch() }) }}
                        label="Route Of Administration"
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <CustomTextField
                        name="presciptionInfo.durationOfNeed"
                        controllerName="presciptionInfo.durationOfNeed"
                        control={control}
                        onChange={(e) => { checkPrescriptionInfoValidity({ ...watch() }) }}
                        label="Duration Of Need"
                      />
                    </Grid>
                  </Grid>
                </BorderedSection>
              </Box> */}
              {/* CS-1187 - END */}
              <Box mt={4} ref={consentRef}>
                <BorderedSection title=" Consent">
                  <Grid container spacing={2} xs={12}>
                    <Grid item xs={12}>
                      <CustomCheckbox
                        control={control}
                        controllerName="orderConsentInfo.clinicalDocumentationNote"
                        label={`Clinical Documentation Note:`}
                        rules={{ required: "Consent is required." }}
                        onChange={(e) => { checkConsentInfoValidity({ ...watch() }) }}
                      // isDisabled={disableAllFields}
                      // rules={{
                      //   required:
                      //     "Please confirm that you are authorized to sign this IVR form on behalf of the provider.",
                      // }}
                      // onChange={(e) => {
                      //   if (e.target.checked === true && selectedProviderData.length > 0) {
                      //     setSignOutSideName(selectedProviderData[0].providerName);
                      //     setSignatureData("");
                      //   } else {
                      //     setSignatureData("");
                      //     setSignOutSideName("");
                      //   }
                      // }}
                      // checked={signatureData ? true : false}
                      />
                    </Grid>
                    <Grid item xs={12} mt={-3}>
                      <ul style={{ fontSize: '12px' }}>
                        <li>Wound Care Indications Discussed</li>
                        {/* CS-1187 - START */}
                        {/* <li>Expected Outcomes Discussed</li> */}
                        {/* <li>Precautions Discussed</li> */}
                        <li>Prevention of Complications Discussed</li>
                        <li>Treatment Plan Discussed</li>
                        <li>Patient Education Provided</li>
                        {/* <li>Patient Alternative Provided</li> */}
                        {/* CS-1187 - END */}
                      </ul>
                    </Grid>
                  </Grid>
                </BorderedSection>
              </Box>
              <Box mt={4}>
                <BorderedSection title="Additional Notes">
                  <Grid container spacing={2} mb={2}>
                    <Grid item md={12} xs={12}>
                      <CustomTextField
                        controllerName="comments"
                        control={control}
                        label="Additional notes/comments"
                        multiline
                        rows={4}
                        maxRows={4}
                        isDisabled={disableAllFields}
                      />
                    </Grid>
                  </Grid>
                </BorderedSection>
              </Box>
              <Grid item md={12} xs={12}></Grid>

              <Grid item md={12} xs={12}>
                <React.Fragment>
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    justifyContent="flex-end"
                    spacing={2}
                    sx={{ pt: 2 }}
                  >
                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        type="submit"
                        onClick={() => setSubmitAction(true)}
                        startIcon={<ExitToApp />}
                        data-allow-submit="true"
                        disabled={shouldShowWarning}

                      >
                        Submit
                      </Button>
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        onClick={onCancelClick}
                        startIcon={<CloseOutlined />}
                        color="error"
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Stack>
                </React.Fragment>
              </Grid>
            </Box>
          </form>
        </Card>
      </Box>
      <CustomAlert
        open={showErrorAlert}
        onClose={() => setShowErrorAlert(false)}
        severity="info"
        message="Feature currently under development. Stay tuned for updates!"
      />
      {showOptionPopup.show &&
        <OptionsPopup
          open={showOptionPopup.show}
          onClose={() => {
            setShowOptionsPopup({ message: "", show: false })
            if(showOptionPopup.variant==="error"){
              setHasHardStop(true)
            }
            }
          }
          variant={showOptionPopup.variant}
          message={<>{showOptionPopup.message}</>}
          buttons={showOptionPopup.buttons}
          title={showOptionPopup.title}
          obj={showOptionPopup.obj}
        />
      }
      {showSignatureSubmitPopup && <SigantureSubmitPopup
        open={showSignatureSubmitPopup}
        onClose={() => { setShowSignatureSubmitPopup(false); }}
        addProductItem={() => { }}
        productItemDetails={{}}
        isEdit={false}
        practiceName={practiceName}
        selectedProviderData={selectedProviderData}
        addSignature={handleSignatureData}
      />}
    </>
  );
};

export default AncillaryOrderForm;
